// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__133YJ","content":"styles_content__1-2EC","tableWrap":"styles_tableWrap__1t4Sc"};